<!-- gc_company_name bind -->

<ng-container *ngIf="(gc_company_name!='' && gc_company_name!=null && gc_company_name!= '-' && gc_company_name!= undefined)">
  <div *ngIf="this.currentUser['role']['id'] == 1" >
    <label class="control-label">{{'requisition.gcCompanyName'|translate}}</label>
    <mat-form-field appearance="outline" class="input-wrapper">
      <input matInput 
       placeholder="{{'requisition.enterGcCompanyName'|translate}}"
       [readonly]="true"
       maxlength="100"
       name="gc_company_name"
       [(ngModel)]="gc_company_name">
    </mat-form-field>
    <br>
  </div>
</ng-container>
